module.exports = "<mat-dialog-content>\r\n    <ng-content></ng-content>\r\n</mat-dialog-content>\r\n"